import React from 'react';
import { Plus } from 'lucide-react';
import EditableText from './EditableText';
import TaskItem from './TaskItem';
import { noteCategories } from './noteCategories';
import { stickyNoteStyles } from './componentStyles';

const MAX_TITLE_LENGTH = 20;

const StickyNotePreview = ({ 
  title,
  category,
  color,
  subtasks,
  onUpdateTitle,
  onEditSubtask,
  onSubtaskAdd,
  onSubtaskDelete
}) => {
  const getCategoryIcon = () => {
    const categoryObj = noteCategories.find(cat => cat.name === category);
    return categoryObj ? categoryObj.icon : null;
  };

  return (
    <div 
      className={`${color} w-72 rounded-lg p-4`}
      style={{
        ...stickyNoteStyles.note,
        position: 'static', // Override the absolute positioning
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transform: 'none'
      }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-start flex-grow overflow-hidden">
          <div className="flex-shrink-0 mr-3 text-gray-600">
            {getCategoryIcon()}
          </div>
          <div className="flex-grow mr-2">
            <EditableText
              text={title}
              maxLength={MAX_TITLE_LENGTH}
              onSave={onUpdateTitle}
              onCancel={() => {}}
              label="Task Title"
              color={color}
            />
          </div>
        </div>
      </div>

      <div className="mb-2 mt-2 max-h-60 overflow-y-auto">
        {subtasks.map((item) => (
          <TaskItem
            key={item.id}
            item={item}
            onToggle={() => {}} // Preview doesn't need toggle functionality
            onDelete={() => onSubtaskDelete(item.id)}
            onEdit={(id, newText) => onEditSubtask(id, newText)}
            color={color}
          />
        ))}
      </div>

      <button
        onClick={onSubtaskAdd}
        className="text-left text-gray-500 hover:text-gray-700 focus:outline-none"
      >
        <Plus size={16} className="inline mr-1" /> Add subtask
      </button>
    </div>
  );
};

export default StickyNotePreview;